import { Controller } from "@hotwired/stimulus"

// Actions to take when the user toggles door(s), from enabling/disabling the Change button, to
// updating the sidebar form to include/exclude this door
export default class extends Controller {
  static values = {
    formGroup: String,
    tgt: String,
    src: String
  }
  
  connect() {
    // Get the row this checkbox belongs to
    const parentElement = document.getElementById(this.formGroupValue);

    // Only enable the Change button if any of the checkboxes are checked
    const groupCheckboxes = parentElement.querySelectorAll('input[type="checkbox"][data-form-group="' + this.formGroupValue + '"]');
    const anyChecked = Array.from(groupCheckboxes).some(checkbox => checkbox.checked);

    document.getElementById(this.formGroupValue + '-btn').disabled = !anyChecked;
  }

  toggle() {
    // Get the entire mass change table
    const parentElement = document.getElementById('mass-change-table');
    let otherCheckboxCount = 0;

    if (parentElement) {  
      const checkboxes = parentElement.querySelectorAll('input[type="checkbox"]');
      /* Uncheck any checkboxes that are not in this formGroup */
      checkboxes.forEach(otherCheckbox => {
        if (otherCheckbox.dataset.formGroup !== this.formGroupValue) {
          if (otherCheckbox.checked) {
            otherCheckboxCount = otherCheckboxCount + 1;
          }
          otherCheckbox.checked = false;
        }
      });

      /* Disable all mass change buttons */
      const buttons = parentElement.querySelectorAll('tr.param-row button');
      buttons.forEach(otherButton => {
        if (otherButton.dataset.formGroup !== this.formGroupValue) {
          otherButton.disabled = true;
        }
      });
    }

    /* Only enable the Change button if any of the checkboxes are checked */
    const groupCheckboxes = parentElement.querySelectorAll('input[type="checkbox"][data-form-group="' + this.formGroupValue + '"]');
    const anyChecked = Array.from(groupCheckboxes).some(checkbox => checkbox.checked);

    document.getElementById(this.formGroupValue + '-btn').disabled = !anyChecked;

    /* If the sidebar form is already displayed for this form group, add/remove this door to the hidden concat_door_ids field */
    const sidebarFormElement = document.querySelector('form[data-form-group="' + this.formGroupValue + '"]');
    if (sidebarFormElement) {
      const concatField = sidebarFormElement.querySelector('input[type="hidden"][name*="concat_door_ids"]');
      if (concatField) {
        let doorAry = concatField.value.split(" ");
        if (doorAry.includes(this.srcValue)) {
          const index = doorAry.indexOf(this.srcValue);
          doorAry.splice(index, 1);
        } else {
          doorAry.push(this.srcValue)
        }
        concatField.value = doorAry.join(" ");
      }
    }

    /* Clear the sidebar if no checkboxes are checked, or the user changes form groups */
    if(!anyChecked || (otherCheckboxCount > 0)) {
      document.getElementById(this.tgtValue).innerHTML = '';
    }
  } 
}
